<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="p-(--padding-card) pt-(--space-2)">
  <div class="mb-(--space-4) flex justify-between items-center">
    <div class="text-h1">{{ getTitle() }}</div>
  </div>

  <ces-wizard-stepper
    [stepsItems]="stepsItems"
    [activeStepIndex]="activeStepIndex()"
    [isCurrentStepValid]="isCurrentStepValid()"
    [submitting]="submitting"
    (previousStepClick)="previousStep()"
    (nextStepClick)="nextStep()"
    (submitClick)="submitForm()" />

  <div class="mt-(--space-8)">
    @if (activeStepIndex() === 0) {
      <app-manual-measure-info [parentForm]="infoGroup" [assetId]="currentAssetId" [existingNames]="existingNamesOnAsset()" />
    }

    @if (activeStepIndex() === 1) {
      <app-manual-measure-formula [parentForm]="formulaGroup" [units]="unitStore.entities()" [measures]="measuresForAsset()" />
    }

    @if (activeStepIndex() === 2) {
      <app-manual-measure-verification
        [parentForm]="verificationGroup"
        [units]="unitStore.entities()"
        [measures]="measuresForAsset()" />
    }
  </div>
</div>
